module.exports = __webpack_public_path__ + "static/media/poste_24.4d6766f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_24.jpg
// module id = 253
// module chunks = 0